module.exports = __webpack_public_path__ + "img/poll-status.768603f6.svg";